import loadable from '@loadable/component';

// 懒加载组件
const OrderQuery = loadable(() => import('./orderQuery/OrderQuery'));
const DeliveryQuery = loadable(() => import('./deliveryQuery/DeliveryQuery'));
const DeliveryModify = loadable(() => import('./deliveryQuery/deliveryModify/DeliveryModify'));
const DeliveryJd903Modify = loadable(() => import('./deliveryQuery/deliveryJd903Modify/DeliveryJd903Modify'));
const EntryInvoice = loadable(() => import('./entryInvoice/EntryInvoice'));

const DeliveryDetailQuery = loadable(() => import('./deliveryDetailQuery/DeliveryDetailQuery'));
const OrderDetailQuery = loadable(() => import('./orderDetailQuery/OrderDetailQuery'));
const DeliveryReturnQuery = loadable(() => import('./deliveryReturnQuery/DeliveryReturnQuery'));
const DeliveryQuery2 = loadable(() => import('./deliveryQuery2/DeliveryQuery'));
const DeliveryModify2 = loadable(() => import('./deliveryQuery2/deliveryModify/DeliveryModify'));

export default [
  {
    // 242301耗材订单查询响应
    path: '/OrderQuery',
    component: OrderQuery
  },
  {
    // 242302耗材发货单查询
    path: '/DeliveryQuery',
    component: DeliveryQuery
  },
  {
    // 242302耗材发货单查询
    path: '/DeliveryModify',
    component: DeliveryModify
  },
  {
    // 242302耗材发货单查询
    path: '/DeliveryJd903Modify',
    component: DeliveryJd903Modify
  },
  {
    // 242308供应商发票补录
    path: '/EntryInvoice',
    component: EntryInvoice
  },
  {
    // 242303耗材发货单明细查询
    path: '/DeliveryDetailQuery',
    component: DeliveryDetailQuery
  },
  {
    // 242303耗材发货单明细查询
    path: '/OrderDetailQuery',
    component: OrderDetailQuery
  },
  {
    // 242304耗材退货单查询确认
    path: '/DeliveryReturnQuery',
    component: DeliveryReturnQuery
  },
  {
    // 242302耗材发货单查询
    path: '/DeliveryQuery2',
    component: DeliveryQuery2
  },
  {
    // 242302耗材发货单查询
    path: '/DeliveryModify2',
    component: DeliveryModify2
  }
];
